import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import './Login.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);  // State to manage password visibility
    const [rememberMe, setRememberMe] = useState(false); // State for "Remember Me" checkbox
    
    const navigate = useNavigate();

    // Check if the user has previously saved login data
    useEffect(() => {
        const savedEmail = localStorage.getItem('email');
        if (savedEmail) {
            setEmail(savedEmail);
            setRememberMe(true); // Auto-check "Remember Me" if the email is in localStorag
        }
    }, []);

    const handleLogin = async (event) => {
        event.preventDefault();
    
        try {
            const response = await fetch('https://api.hgcdental.clinic/api/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    email: email.trim().toLowerCase(), 
                    password 
                }),
                credentials: 'include', // Important for sessions
            });
    
            const data = await response.json();
    
            if (response.ok) {
                console.log('Login successful:', data);
                
                // Save email if "Remember Me" is checked
                if (rememberMe) {
                    localStorage.setItem('email', email);
                } else {
                    localStorage.removeItem('email');
                }
    
                // Redirect based on user type
                if (data.isInternal || data.userType === 'InternalUsers') {
                    navigate('/dashboard');
                } else {
                    navigate('/appointments-users-calendar');
                }
            } else {
                setErrorMessage(data.error || data.message || 'Login failed');
            }
        } catch (error) {
            console.error('Login error:', error);
            setErrorMessage('Network error. Please try again.');
        }
    };

    return (
        <div className="login-container">
            <Header />
            <div className="login-content">
                <div className="login-card">
                    <h1 className="login-title">Welcome Back!</h1>
                    <p className="login-description">Log in to access your dashboard.</p>

                    <form onSubmit={handleLogin} className="login-form">
                        <div className="login-form-group-email">
                            <label htmlFor="email">Email</label>
                            <input 
                                type="email" 
                                id="email" 
                                value={email} 
                                onChange={(e) => setEmail(e.target.value)} 
                                required 
                                placeholder="Enter your email"
                                className="modal-input"
                            />
                        </div>
                        <div className="login-form-group">
                            <label htmlFor="password">Password</label>
                            <div className="password-container">
                                <input 
                                    type={showPassword ? 'text' : 'password'}  // Toggle input type
                                    id="password" 
                                    value={password} 
                                    onChange={(e) => setPassword(e.target.value)} 
                                    required 
                                    placeholder="Enter your password"
                                    className="modal-input"
                                />
                                <span 
                                    className="eye-icon" 
                                    onClick={() => setShowPassword(!showPassword)}  // Toggle password visibility
                                >
                                    {showPassword ? (
                                        <i className="fas fa-eye-slash"></i>  // Font Awesome icon for password hidden
                                    ) : (
                                        <i className="fas fa-eye"></i>  // Font Awesome icon for password visible
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className="login-form-group remember-me">
                            <label>
                                <input 
                                    type="checkbox" 
                                    checked={rememberMe} 
                                    onChange={(e) => setRememberMe(e.target.checked)} 
                                />
                                Remember Me
                            </label>
                        </div>
                    <a href="/forgot-password" className="forgot-password-link">Forgot Password?</a>
                        <button type="submit" className="login-button">Log In</button>
                        <p className="signup-link">Don't have an account? <a href='SignUp'>Sign Up</a></p>
                    </form>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                </div>
            </div>
        </div>
    );
};

export default Login;
//why